<template>
  <div class="containar">
    <div style="float: left;width: 100%;height: 20%">
      <div id="logoDiv">
        <img src="../../../static/img/logo.png" id="logo">
      </div>
      <div id="logotextDiv">
        <span style="font-size: 20px">甘肃智通科技工程检测咨询有限公司</span><br>
        <span style="font-size: 20px">Gansu ZhiTong Technology Enginnering Detection Consulting Co.,LTD</span><br>
        <span style="font-weight:bold;font-size: 30px">公路工程试验检测资产管理系统</span><br>
        <span style="font-weight:bold;font-size: 10px">MANAGEMENT SYSTEM OF HIGHWAY ENGINEERING TEST AND DETECTION
          EQUIPMENT2.0</span><br>
      </div>
    </div>
    <div id="logoimgDiv">
      <img src="../../../static/img/bg2.png" style="height: 100%;width: 100%">
    </div>
    <div id="loginFormDiv">
      <p style="text-align: left;margin-left: 15px;height: 50px;line-height: 50px;font-size: 20px">忘记密码</p>

      <!-- 步骤1：输入账号 -->
      <div v-if="step === 1" style="padding: 0 15px;">
        <el-input v-model="form.userId" placeholder="请输入账号" prefix-icon="el-icon-user"
          style="margin-bottom:12px;" @blur="onUserIdBlur">
        </el-input>
        <div v-if="maskedTel" style="color:#666;font-size:13px;margin-bottom:12px;">
          绑定手机：{{ maskedTel }}
        </div>
        <el-button type="primary" style="width:100%;" @click="handleSendCode" :loading="codeLoading" :disabled="timeNum < 60 && timeNum > 0">
          {{ timeNum < 60 ? `${timeNum}s后重新获取` : '发送验证码' }}
        </el-button>
        <div style="display:flex;gap:8px;margin-top:12px;">
          <el-input v-model="captchaCode" placeholder="图形验证码" maxlength="4" style="flex:1;">
          </el-input>
          <el-image :src="captchaImg" @click="getCaptcha" style="width:100px;height:40px;cursor:pointer;border-radius:4px;border:1px solid #ddd;flex-shrink:0;" fit="fill"></el-image>
        </div>
        <div style="margin-top:20px;">
          <el-input v-model="form.code" placeholder="请输入验证码" style="margin-bottom:12px;" maxlength="6">
          </el-input>
          <el-button type="success" style="width:100%;" @click="handleVerifyCode">下一步</el-button>
        </div>
        <div style="text-align:center;margin-top:12px;">
          <router-link to="/login" style="color:#409EFF;font-size:13px;">返回登录</router-link>
        </div>
      </div>

      <!-- 步骤2：输入新密码 -->
      <div v-if="step === 2" style="padding: 0 15px;">
        <p style="color:#67C23A;font-size:13px;margin-bottom:15px;">验证通过，请设置新密码</p>
        <el-input v-model="form.password" placeholder="请输入新密码" type="password" show-password
          style="margin-bottom:12px;">
        </el-input>
        <el-input v-model="form.confirmPwd" placeholder="请再次输入新密码" type="password" show-password
          style="margin-bottom:16px;">
        </el-input>
        <el-button type="primary" style="width:100%;" @click="handleResetAndLogin" :loading="resetting">确认并登录</el-button>
        <div style="text-align:center;margin-top:12px;">
          <a href="javascript:;" @click="step=1" style="color:#409EFF;font-size:13px;">返回上一步</a>
        </div>
      </div>
    </div>
    <FooterBar />
  </div>
</template>

<script>
import { getSms, lookupPhone, verifySmsCode, resetPwdAndLogin } from "../../api/api"
import FooterBar from "../../components/FooterBar"
import axios from 'axios'
import { base } from '../../api/api'
export default {
  name: "PasswordForget",
  components: { FooterBar },
  data() {
    return {
      step: 1,           // 1=输入账号验证码, 2=输入新密码
      maskedTel: '',
      codeLoading: false,
      resetting: false,
      timeNum: 60,
      timer: null,
      captchaImg: '',
      captchaCode: '',
      form: {
        userId: '',
        code: '',
        password: '',
        confirmPwd: ''
      }
    }
  },
  mounted() {
    this.getCaptcha();
  },
  methods: {
    // 输入账号后自动查询手机号
    onUserIdBlur() {
      if (!this.form.userId) {
        this.maskedTel = ''
        return
      }
      lookupPhone({ userId: this.form.userId }).then(res => {
        if (res.status == 200 && res.data) {
          this.maskedTel = res.data.tel
        } else {
          this.maskedTel = ''
          this.$message({ message: res.message || '未找到该账号', type: 'warning' })
        }
      })
    },
    // 发送验证码
    handleSendCode() {
      if (!this.form.userId) {
        this.$message({ message: '请先输入账号', type: 'warning' })
        return
      }
      if (!this.captchaCode) {
        this.$message({ message: '请输入图形验证码', type: 'warning' })
        return
      }
      if (this.timeNum < 60) return
      this.codeLoading = true
      getSms({ userId: this.form.userId, verifyCode: this.captchaCode }).then(res => {
        if (res.status == 200) {
          this.$message({ message: '验证码已发送', type: 'success' })
          this.captchaCode = ''
          this.getCaptcha()
          this.startTimer()
        } else {
          this.$message({ message: res.message || '发送失败', type: 'warning' })
          this.captchaCode = ''
          this.getCaptcha()
          this.codeLoading = false
        }
      }).catch(() => {
        this.$message({ message: '发送失败，请重试', type: 'error' })
        this.codeLoading = false
        this.getCaptcha()
      })
    },
    // 验证验证码
    handleVerifyCode() {
      if (!this.form.code) {
        this.$message({ message: '请输入验证码', type: 'warning' })
        return
      }
      verifySmsCode({ userId: this.form.userId, code: this.form.code }).then(res => {
        if (res.status == 200) {
          this.step = 2
        } else {
          this.$message({ message: res.message || '验证码错误', type: 'warning' })
        }
      })
    },
    // 重置密码并登录
    handleResetAndLogin() {
      if (!this.form.password) {
        this.$message({ message: '请输入新密码', type: 'warning' })
        return
      }
      if (this.form.password.length < 6) {
        this.$message({ message: '密码至少6位', type: 'warning' })
        return
      }
      if (this.form.password !== this.form.confirmPwd) {
        this.$message({ message: '两次输入的密码不一致', type: 'warning' })
        return
      }
      this.resetting = true
      resetPwdAndLogin({ userId: this.form.userId, password: this.form.password }).then(res => {
        if (res.status == 200) {
          // 自动登录
          localStorage.setItem("user", JSON.stringify(res.data))
          localStorage.setItem("token", new Date().getTime())
          localStorage.setItem("theme", "#0680c7")
          localStorage.setItem("header", "#10a1d2")
          localStorage.setItem("loading", false)
          this.$message({ message: '密码重置成功，正在登录...', type: 'success' })
          setTimeout(() => {
            this.$router.push({ path: "/DeviceInfo", name: "设备信息", title: "设备信息" })
          }, 1500)
        } else {
          this.$message({ message: res.message || '重置失败', type: 'warning' })
          this.resetting = false
        }
      }).catch(() => {
        this.$message({ message: '请求失败，请重试', type: 'error' })
        this.resetting = false
      })
    },
    getCaptcha() {
      this.captchaImg = '';
      axios.get(`${base}/user/code`, {
        responseType: 'blob',
        params: { _t: Date.now() + '_' + Math.random().toString(36).slice(2) }
      }).then(response => {
        const url = URL.createObjectURL(response.data);
        this.captchaImg = url;
      }).catch(() => {
        this.captchaImg = '';
      });
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    startTimer() {
      this.clearTimer()
      this.timeNum = 59
      this.timer = setInterval(() => {
        this.timeNum--
        if (this.timeNum <= 0) {
          this.timeNum = 60
          this.codeLoading = false
          this.clearTimer()
        }
      }, 1000)
    }
  },
  beforeDestroy() {
    this.clearTimer()
  }
}
</script>

<style scoped>
body {
  margin: 0px;
  padding: 0px;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}

.containar {
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100vw;
  background-color: #255F9E;
  caret-color: transparent;
  user-select: none;
}

#logoDiv { width: 90px; height: 90px; margin-left: 15px; }
#logo { width: 100%; height: 100%; }
#logotextDiv {
  position: absolute; left: 120px; top: 1%; width: 700px; height: 10%;
  text-align: left; color: white;
}
#logoimgDiv { width: 40%; height: 73%; }

#loginFormDiv {
  position: relative; left: 65%; bottom: 45%; background-color: white;
  border-radius: 5%; width: 350px;
  padding-bottom: 20px;
  user-select: text; caret-color: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/users/PasswordForget.vue